<template>
  <InfuseModal
    :title="t('iam.permissions.grant_permissions.header')"
    :description="t('iam.permissions.grant_permissions.description')"
    @close="emit('close')"
    :disable-close="loading"
  >
    <div class="flex max-h-[70vh] min-h-[70vh] min-w-[80rem] max-w-[80rem] justify-center overflow-y-auto">
      <div class="w-full">
        <div v-if="subscriptions && subscriptions.length" class="mb-2">
          <InfuseSegments>
            <InfuseSegment
              v-for="subscription in subscriptions"
              :key="subscription.id"
              :active="activeSubscription?.id === subscription.id"
              :name="subscription.name"
              :label="() => subscription.name"
              @click="activeSubscription = subscription"
            />
          </InfuseSegments>
        </div>
        <PermissionsSelector
          :permissions="permissions.filter((p) => p.subscriptionId === activeSubscription?.id)"
          :enabled-permissions="enabledPermissions"
          :loading="loading"
          :search-query="searchQuery"
          :force-max-height="true"
          @add="(id) => emit('add', id)"
          @remove="(id) => emit('remove', id)"
          @clear="(cat) => emit('clear', cat)"
          @readOnly="(cat) => emit('readOnly', cat)"
          @all="(cat) => emit('all', cat)"
          @update:searchQuery="(q) => emit('update:searchQuery', q)"
        />
      </div>
    </div>
    <template #actions>
      <InfuseButton data-testid="modal-confirm-button" @click="emit('save')" :disabled="loading" :loading="isGranting">
        {{ t('action.save') }}
      </InfuseButton>
    </template>
  </InfuseModal>
</template>

<script setup lang="ts">
import { usePermissionsSubscriptionFilter } from '@infuse/iam/composables';
import { PermissionsSelector } from '@infuse/iam/permission/ui';
import { InfuseButton, InfuseModal, InfuseSegment, InfuseSegments } from '@infuse/ui/components';
import { toRef } from 'vue';
import { useI18n } from 'vue-i18n';
import { Permission } from '@infuse/iam/permission/domain';

const { t } = useI18n();
const emit = defineEmits(['close', 'add', 'remove', 'clear', 'readOnly', 'all', 'save', 'update:searchQuery']);

const props = defineProps<{
  permissions: Permission[];
  enabledPermissions: string[];
  loading?: boolean;
  isGranting?: boolean;
  searchQuery?: string;
}>();

const { subscriptions, activeSubscription } = usePermissionsSubscriptionFilter(toRef(props.permissions));
</script>
